import {
  markNoRead,
  unmarkNoRead,
  updateInformationOfNoReadInDb,
} from "../actions";
import { dispareReadingMsg } from "../actions/websocket";
import { EChannels } from "./EChannels";

class NoReadHandler {
  STORAGE_KEY = "noReadInformation";
  NOT_ALLOWED_CHANNELS = [EChannels.VOICE, EChannels.WHATSAPPVOICE];
  isLoaded = false;

  setIsLoaded() {
    this.isLoaded = true;
  }
  clearIsLoaded() {
    this.isLoaded = false;
  }
  isNoReadChat(chat) {
    if (!Boolean(chat)) return false;
    return chat.isNoRead || chat.qtdmessage > 0 || false;
  }

  hasThisItemInStorage(idatendimento) {
    const noReadInfos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(noReadInfos)) return false;
    const noReadInfosParsed = JSON.parse(noReadInfos);
    return `${idatendimento}` in noReadInfosParsed || false;
  }
  addNoReadInfoInStorage(idatendimento, isNoRead = false, idmidia = 5) {
    if (this.NOT_ALLOWED_CHANNELS.includes(parseInt(idmidia))) return;
    const infos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(infos)) {
      localStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify({ [`${idatendimento}`]: isNoRead }),
      );
      return;
    }
    localStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify({
        ...JSON.parse(infos),
        [`${idatendimento}`]: isNoRead,
      }),
    );
  }

  removeNoReadInfoInStorage(idatendimento) {
    const infos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(infos)) return;
    const hasThisId = infos[`${idatendimento}`];
    if (!hasThisId) return;
    const infosParsed = JSON.parse(infos);
    delete infosParsed[`${idatendimento}`];
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(infosParsed));
  }

  markNoReadChat(
    dispatch,
    idatendimento,
    avoidInsertionInDb = false,
    idmidia = 5,
  ) {
    this.addNoReadInfoInStorage(idatendimento, true, idmidia);
    dispatch(markNoRead(idatendimento));
    if (!avoidInsertionInDb) {
      updateInformationOfNoReadInDb(idatendimento, true);
    }
  }

  isToInsertNoReadFalseInDb(idatendimento) {
    return (
      !this.hasThisItemInStorage(idatendimento) ||
      (this.hasThisItemInStorage(idatendimento) && this.isNoRead(idatendimento))
    );
  }

  unmarkNoReadChat(
    dispatch,
    idatendimento,
    atendimento,
    informationusers,
    avoidInsertionInDb = false,
    idmidia = 5,
  ) {
    const isToInsertNoReadFalseInDb =
      this.isToInsertNoReadFalseInDb(idatendimento);
    this.addNoReadInfoInStorage(idatendimento, false, idmidia);
    dispatch(unmarkNoRead(idatendimento));
    if (isToInsertNoReadFalseInDb && !avoidInsertionInDb) {
      updateInformationOfNoReadInDb(idatendimento, false);
    }
    if (Boolean(atendimento) && Boolean(informationusers)) {
      dispatch(dispareReadingMsg(atendimento, informationusers));
    }
  }

  isNoRead(idatendimento) {
    if (!this.hasThisItemInStorage(idatendimento)) return false;
    const infos = localStorage.getItem(this.STORAGE_KEY);
    const infosParsed = JSON.parse(infos);
    return infosParsed[`${idatendimento}`] || false;
  }

  verifyIfThisAtdHasParamIsNoRead(getState, idatendimento) {
    if (!Boolean(getState) || !Boolean(idatendimento)) return false;
    const { atdsimult } = getState();

    const atd = atdsimult.find(
      (item) => parseInt(item.idatendimento) === parseInt(idatendimento),
    );

    if (!Boolean(atd)) return false;

    return atd.isNoRead || false;
  }

  removeOldNoReadInfoInStorage(atdsimult) {
    const infos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(infos)) return;
    const hasAtdsimult = Array.isArray(atdsimult) && atdsimult.length > 0;
    if (!hasAtdsimult) return;
    const infosParsed = JSON.parse(infos);
    for (const item of Object.keys(infosParsed)) {
      const hasThisId = atdsimult.find(
        (atd) => parseInt(atd.idatendimento) === parseInt(item),
      );
      if (!hasThisId) {
        this.removeNoReadInfoInStorage(item);
      }
    }
  }

  isAllowedChannel(midiaId) {
    return !this.NOT_ALLOWED_CHANNELS.includes(parseInt(midiaId));
  }
}

export const noReadHandler = new NoReadHandler();
